import React from 'react';
import $ from 'jquery';
import ResourceService from '../../services/resource.service';
import CommonMessage from '../common/commonMessage';
import Validate from '../common/validate';
import ReactTooltip from 'react-tooltip';
import { isNumber, maskEmail } from '../../utility/utility';
import { API_HOST, axiosInstance, axiosRequestWithAuth } from '../../constants/server.constant';
import Axios from 'axios';
import SessionService from '../../services/session.service';
import ReCAPTCHA from "react-google-recaptcha";
import { loginService } from '../../services/login.service';
import i18n from '../../i18n';
import { userService } from './../../services/user.service';

class TwoFaVerification extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isEmailVerify: false,
            isPhoneVerify: false,
            isTotpVerify: false,
            isCodeExpired: false,
            message: "",
            msgType: '',
            email: localStorage.getItem('email'),
            phoneCode: localStorage.getItem('countryCode'),
            phone: localStorage.getItem('phone'),
            timerId: '',
            isOtpSent: false,
            otp: '',
            errorMssg: '',
            countryCode: this.getCountryCode(localStorage.getItem('countryCode')),
            totpCode: '',
            isTotpMsg: '',
            userId: localStorage.getItem('userId'),
            isAction: true,
            isSubscribed: true
        };
        this.recaptchaRef = React.createRef();

    }

    componentWillUnmount() {
        clearInterval(this.timerId);

    }

    getCountryCode(phoneCode) {
        if(phoneCode === undefined || phoneCode === null) return '';
        var c = phoneCode.split('+');
        var cCode = '+' + c[1];
        return cCode;
    }
    sendOtp = (type) => {
        var cLabel = this.state.phoneCode;
        var c = cLabel.split('+');
        var cCode = '+' + c[1];
        var otpDetails = {
            "email": this.state.email,
            "countryCode": cCode.trim(),
            "phone": this.state.phone
        };
        if(type == 1) {
            this.setState({
                otpDetails: otpDetails,
                captchaType: "email"
            }, () => this.recaptchaRef.current.execute());

        } else if(type == 2) {
            this.setState({
                otpDetails: otpDetails,
                captchaType: "sms"
            }, () => this.recaptchaRef.current.execute());


        }
    };
    onRecaptchaChange = (event) => {
        if(this.state.captchaType == "email") {
            this.sendEmailOtp(this.state.otpDetails, event);
        }
        else {
            this.sendPhoneOtp(this.state.otpDetails, event);
        }

    };

    sendEmailByLink() {
        this.setState({ isPhoneVerify: false, isEmailVerify: true, isTotpVerify: false });
        this.sendOtp(1);
    }
    sendEmailOtp(otpDetails, event) {
        ResourceService.sendEmailOtp(otpDetails, event).then(res => {
            if(res === undefined) {
                this.setState({
                    message: "Email could not be verified.",
                    msgType: 'error',
                    isAction: false
                });
                if(this.recaptchaRef.current)
                    this.recaptchaRef.current.reset();
                //this.phoneNUmberFocus.current.focus()
            } else if(res === "TOO_MANY_CALLS") {
                this.setState({
                    message: i18n.t('exceeded_query_limit'),
                    msgType: 'error',
                    isAction: false
                });
                if(this.recaptchaRef.current) {
                    this.recaptchaRef.current.reset();
                }
            } else {
                this.setState({ isOtpSent: true, message: 'Verification code has been sent', isCodeExpired: false, msgType: "success", isAction: false });

                clearInterval(this.timerId);
                this.startTimer();
                //$('#verify_otp_msg').hide();
                $('#otp').removeAttr('disabled');
                $('#resend_msg').show();
                // setTimeout(() => {
                //     $('#resend_msg').hide();
                // }, 3000);
                //this.otpInput.current.focus()
            }
        }).catch(error => {
            if(error?.response?.status === 409) {
                loginService.redirectToLogin(this.state.userId, true);
            } else {
                this.setState({
                    message: i18n.t('Error while sending verification code.'),
                    msgType: "error",
                    isAction: false
                });
                if(this.recaptchaRef.current)
                    this.recaptchaRef.current.reset();
            }
        });
    }

    sendPhoneOtp(otpDetails, event) {
        ResourceService.sendOtp(otpDetails, event).then(res => {
            if(res === undefined) {
                this.setState({
                    message: "Phone number could not be verified. Enter a valid phone number and try again.",
                    msgType: 'error',
                    isAction: false
                });
                if(this.recaptchaRef.current)
                    this.recaptchaRef.current.reset();
                //this.phoneNUmberFocus.current.focus()
            } else if(res === "TOO_MANY_CALLS") {
                this.setState({
                    message: i18n.t('exceeded_query_limit'),
                    msgType: 'error',
                    isAction: false
                });
                if(this.recaptchaRef.current) {
                    this.recaptchaRef.current.reset();
                }
            } else {
                this.setState({ isOtpSent: true, message: 'Verification code has been sent', isCodeExpired: false, msgType: 'success', isAction: false });

                clearInterval(this.timerId);
                this.startTimer();
                //$('#verify_otp_msg').hide();
                $('#otp').removeAttr('disabled');
                $('#resend_msg').show();
                // setTimeout(() => {
                //     $('#resend_msg').hide();
                // }, 3000);
                //this.otpInput.current.focus()
            }
        });
    }

    verifyOtp() {
        if(this.state.otp === undefined || this.state.otp.trim() === '') {
            this.setState({ message: 'Verification code cannot be blank', msgType: 'error' });
            $('#otp').focus();
            return;
        }
        var otpDetails = {
            "email": this.state.email,
            "otp": this.state.otp.trim()
        };
        ResourceService.verifyOtp(otpDetails).then(response => {
            this.redirectAfterVerification(response);
        }).catch(error => {
            if(this.recaptchaRef.current)
                this.recaptchaRef.current.reset();
            $('#otp').focus();
            if(error?.response?.data) {
                let data = error.response.data;
                if(data?.error) {
                    switch(data.error) {
                        case "invalid_credentials":
                            this.setState({
                                isAction: false,
                                otpErr: true,
                                message: "Incorrect verification code. Please try again.",
                                msgType: "error"
                            });
                            return;
                        case "exceeded_retries":
                            this.setState({
                                isAction: false,
                                otpErr: true,
                                message: "Exceeded query limit. Please try after some time.",
                                msgType: "error"
                            });
                            return;
                        default: break;
                    }
                }
            }
            this.setState({
                isAction: false,
                otpErr: true,
                message: "Error while verifying OTP",
                msgType: "error"
            });
            return;
        });
    }

    inputChangeHandler = (event) => {
        let name = event.target.name;
        let val = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        if(name === 'otp') {
            if(val !== '' && !isNumber(val)) {
                return;
            }
        }
        this.setState({ [name]: val });
    };

    startTimer() {
        //var mindisp = 0;
        //var secdis = 0;
        $("#otp_timer").html("Your verification code will expire in <b> 05:00 </b> Minutes");
        var countdown = 5 * 60 * 1000;
        //var timerId ;
        //clearInterval(timerId);
        this.timerId = setInterval(() => {
            countdown -= 1000;
            var min = Math.floor(countdown / (60 * 1000));
            //var sec = Math.floor(countdown - (min * 60 * 1000));  // wrong
            var sec = Math.floor((countdown - (min * 60 * 1000)) / 1000);
            if(min == 0 && sec == 0) {
                clearInterval(this.timerId);
                $('#otp_timer').html('The verification code has expired. Click "Resend OTP" to receive new code.');
                this.setState({
                    otp: "",
                    isOtpSent: false

                }, () => {
                    $('#otp').attr("disabled", "disabled");
                    this.setState({ isCodeExpired: true });
                });
            } else {
                this.mindisp = min;
                this.secdis = sec;
                if(min < 10)
                    this.mindisp = "0" + min;
                if(sec < 10)
                    this.secdis = "0" + sec;
                if(min == 0) {
                    $("#otp_timer").html("Your verification code will expire in <b>" + this.mindisp + ":" + this.secdis + "</b> Seconds");
                } else {
                    $("#otp_timer").html("Your verification code will expire in <b>" + this.mindisp + ":" + this.secdis + "</b> Minutes");
                }
            }

        }, 1000);
    }

    topBackbttnClick() {
        loginService.redirectToLogin();
        //this.props.history.push('/login')
    }

    resendOtp() {
        this.setState({ isResendClicked: true, isAction: true });

        if(this.state.isEmailVerify) {
            this.sendOtp(1);
        } else if(this.state.isPhoneVerify) {
            this.sendOtp(2);
        }
        $('#otp').focus();
        var timeout = setTimeout(() => {
            this.setState({ isResendClicked: false });
            clearTimeout(timeout);
        }, 10000);
    }

    componentDidMount() {
        ResourceService.getPageInfo().then(resp => {
            if(resp && resp !== '') {
                if(!resp.includes(window.location.href)) {
                    this.topBackbttnClick();
                } else {
                    var url = new URL(window.location.href);
                    var ty = url.searchParams.get("ty");

                    setTimeout(() => $('#otp').focus(), 300);

                    if(ty == 2 || ty == 1) {
                        if(ty == 1) {
                            this.setState({ isEmailVerify: true, isAction: false });
                        } else {
                            this.setState({ isPhoneVerify: true, isAction: false });
                        }
                        this.sendOtp(ty);
                    } else {
                        this.setState({ isTotpVerify: true, isAction: false });
                    }
                }
            }
        });
        this.checkForSubscription();

    }

    verifyTotp = (event) => {

        if(this.state.totpCode.trim().length <= 0) {
            this.setState({ message: 'Totp code cannot be blank', msgType: 'error' });
        } else if(!Validate("otp", this.state.totpCode.trim())) {
            this.setState({ message: 'Totp code should be of six digit and only numbers', msgType: 'error' });
        } else {
            this.setState({
                isAction: true, message: '', msgType: ''
            });
            axiosInstance.post("/2fa/totp/verify/add/" + this.state.userId + "?code=" + this.state.totpCode, null, axiosRequestWithAuth).then(resp => {
                this.redirectAfterVerification(resp);
            }).catch(error => {
                if(error?.response?.status === 417) {
                    this.setState({
                        isAction: false,
                        message: 'Invalid TOTP code, please try again',
                        msgType: 'error',
                        isTotpMsg: false,
                        viewTotpMessage: ''
                    });
                } else if(error?.response?.status === 403) {
                    this.setState({
                        isAction: false,
                        message: 'Forbidden Access. Verfication terminated.',
                        msgType: 'error',
                        isTotpMsg: false,
                        viewTotpMessage: '',
                    });
                } else {
                    this.setState({
                        isAction: false,
                        // totpEmpty:true,
                        message: 'Unable to verify TOTP. Please try again later.',
                        msgType: 'error',
                        isTotpMsg: false,
                        viewTotpMessage: ""
                    });
                }
            });
        }
    };

    on2faKeydown(e, name) {
        if(e.keyCode === 13) {
            if(name === 'verifyOtp') {
                this.verifyOtp();
            }
            if(name === 'verifyTotp') {
                this.verifyTotp();
            }
        }

    }

    redirectAfterVerification = (resp) => {
        debugger;
        let state = { from2fa: true };
        if(resp?.data?.emailTransfer) state.emailTransfer = resp.data.emailTransfer;
        userService.getUser().then((response) => {
            loginService.setUserLocal(response, true);
            let redirectUrl = SessionService.getCookie("_redirect_url");
            if(typeof redirectUrl !== 'undefined') {
                this.props.history.push({ pathname: redirectUrl, state: state });
                loginService.deleteCookie("_redirect_url", "/app");
            }
            else if(this.state.isSubscribed === false) {
                this.props.history.push({ pathname: '/billing/creditcard', state: state });
            } else {
                this.props.history.push({ pathname: '/index', state: state });
            }
        }).catch((error) => {
            console.error("Error while fetching user details after two-fa verification ...");
            loginService.redirectToLogin();
        });
    };

    redirectToIndex() {
        window.location = "https://www.idrivecompute.com/index.html";
    }

    checkForSubscription = () => {
        ResourceService.getSubscriptionDetails().then(resp => {
            if(resp === false) {
                this.setState({
                    message: "Error while getting user subscription details",
                    msgType: 'error'
                });
                return;
            }
            if(resp.error) {
                this.setState({ isSubscribed: false });
            } else {
                this.setState({ isSubscribed: true });
            }

        });
    };

    render() {
        var emailMask = this.state.email;
        //var emailHalf = emailMask.replace(/^(.)(.*)(.@.*)$/,(_, a, b, c) => a + b.replace(/./g, '*') + c);
        var emailHalf = maskEmail(emailMask);
        var phone = this.state.phone;
        var phoneNoMask = '';
        if(phone) {
            phoneNoMask = phone.slice(0, 2) + phone.slice(2).replace(/.(?=...)/g, '*');
        }
        return (
            <div className="idcmp-frontend-main">
                <div className="full_page_loader" style={ { display: this.state.isAction ? 'block' : 'none' } }>
                    <div className="loader_icon"></div>
                </div>
                <header>
                    <div className="idcmp-2fa-container">
                        <a href="#" className="back_btn" onClick={ (e) => { this.topBackbttnClick(); e.preventDefault(); } } data-tip data-for="back">
                            <span >
                                <svg x="0px" y="0px" width="50px" height="30px" viewBox="0 0 50 30" enableBackground="new 0 0 50 30" xmlSpace="preserve">
                                    <g>
                                        <path fill="#F3F3F3" d="M49,3.01v23.98C49,28.1,48.1,29,47,29H3c-1.1,0-2-0.9-2-2.01V3.01C1,1.9,1.9,1,3,1h44
                            C48.1,1,49,1.9,49,3.01z"></path>
                                        <path fill="#CCCCCB" d="M47,0H3C1.34,0,0,1.35,0,3.01v23.98C0,28.65,1.34,30,3,30h44c1.66,0,3-1.35,3-3.01V3.01
                            C50,1.35,48.66,0,47,0z M49,26.99C49,28.1,48.1,29,47,29H3c-1.1,0-2-0.9-2-2.01V3.01C1,1.9,1.9,1,3,1h44c1.1,0,2,0.9,2,2.01V26.99z
                            "></path>
                                    </g>
                                    <polygon fill="#636363" points="33,10 33,15.99 23,16 23,21 17,15 23,9 23,14 31,14 31,10 "></polygon>
                                </svg>
                            </span>
                        </a><ReactTooltip id="back" place="right" effect="solid">Back to login</ReactTooltip>
                        <div className="idcmp-logo" onClick={ () => this.redirectToIndex() }>
                            <a href="#" ><img src="https://www.idrivecompute.com/webapp/images/computelogo_blue.svg" alt="IDrive Compute Logo" /></a>
                        </div>
                    </div>
                </header>
                <div className="idcmp-2fa-wrpr" style={ { display: this.state.isAction ? 'none' : '' } }>
                    <div className="idcmp-alert warning idcmp-hide">
                        <p>Your verification code has been sent!</p>
                        <span className="alt-close">×</span>
                    </div>
                    <div className="idcmp-2fa-blk">
                        { this.state.isTotpVerify && <h1 className="idcmp-2fa-title">Two-factor authentication via Time-based OTP authentication</h1> }
                        { !this.state.isTotpVerify && <h1 className="idcmp-2fa-title">Two-factor authentication</h1> }

                        { this.state.isPhoneVerify && !this.state.isCodeExpired && <p className="idcmp-2fa-content">Enter the verification code sent to your registered mobile number<br /><i>{ this.state.countryCode } { phoneNoMask }  </i></p> }
                        { this.state.isEmailVerify && !this.state.isCodeExpired && <p className="idcmp-2fa-content">Enter the verification code sent to your registered email address<br /><i>{ emailHalf }</i></p> }
                        { this.state.isTotpVerify && <p className="idcmp-2fa-content">Enter the one-time code generated by Time-based OTP Authenticator<br /> app in your mobile device, to login to your account.</p> }

                        <div className="idcmp-2fa-code-blk">
                            { !this.state.isTotpVerify &&
                                <div className={ this.state.isEmailVerify ? "idcmp-verfy-blk idcmp-email-verify" : "idcmp-verfy-blk idcmp-mobile-verify" }>
                                    { this.state.isCodeExpired ? <h2>Your verification code has expired!</h2> : <h2>Verification code</h2> }
                                    { !this.state.isCodeExpired && <input type="password" name="otp" className="idcmp-frm-ctrl" id="otp" value={ this.state.otp } onChange={ (e) => this.inputChangeHandler(e) } autoComplete="off" maxLength="6" onKeyDown={ (e) => this.on2faKeydown(e, 'verifyOtp') } /> }
                                    { !this.state.isCodeExpired && <input type="submit" className="idcmp-btn idcmp-primary-btn" value="Verify" onClick={ () => this.verifyOtp() } /> }
                                    { !this.state.isCodeExpired && <p>If you have not received your code, <a href="#" onClick={ (e) => { e.preventDefault(); this.resendOtp(); } } className={ this.state.isResendClicked ? "disabled" : "" }>click here to resend.</a></p> }
                                    { this.state.isCodeExpired && <input type="submit" className="idcmp-btn idcmp-primary-btn" value="Resend Now!" onClick={ () => this.resendOtp() }></input> }
                                </div>
                            }
                            { this.state.isTotpVerify &&
                                <div className="idcmp-verfy-blk idcmp-email-verify">
                                    <h2>Enter one-time code</h2>
                                    <input type="password" className="idcmp-frm-ctrl" value={ this.state.totpCode } name="totpCode" onChange={ (e) => this.inputChangeHandler(e) } autoComplete="chrome-off" maxLength="6" onKeyDown={ (e) => this.on2faKeydown(e, 'verifyTotp') } />
                                    <input type="submit" className="idcmp-btn idcmp-primary-btn" value="Submit Code" placeholder="Enter code" onClick={ () => this.verifyTotp() } />

                                    <p><a href="#" onClick={ (e) => { this.props.history.push('2fa-deactivate'); e.preventDefault(); } }>I can't access my code.</a></p>
                                </div>
                            }

                        </div>
                        { !this.state.isTotpVerify && this.state.isOtpSent && <p className="idcmp-code-timer" id="otp_timer"></p> }
                        { (this.state.isTotpVerify || this.state.isPhoneVerify) && !this.state.isCodeExpired && <p className="idcmp-2fa-alternate"><a href="#" title="Verify code via email address" onClick={ (e) => { this.sendEmailByLink(); e.preventDefault(); } }>Verify code via email address</a> </p> }
                        {/* <p className="idcmp-2fa-alternate"><a href="#" title="#" id="TOTP">Verify code via Time-based OTP Authenticator app</a> </p>  */ }
                    </div>
                </div>
                <footer>
                    <p className="idcmp-copy">© IDrive Inc.</p>
                </footer>
                <CommonMessage message={ this.state.message } msgType={ this.state.msgType } handler={ () => this.setState({ message: "" }) } />
                <div className="captcha">
                    <ReCAPTCHA
                        sitekey="6LfMaG8aAAAAADtCmgI91y-9wbCjnaDTQwwIUv6-"
                        onChange={ (e) => this.onRecaptchaChange(e) }
                        ref={ this.recaptchaRef }
                        size="invisible"
                    />
                </div>
            </div>
        );
    }
}

export default TwoFaVerification;